module.exports = __webpack_public_path__ + "static/img/006.8caa0fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/006.png
// module id = /PEu
// module chunks = 1